import React, { useState } from "react";
import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import social_list from "../assets/contents/social-media-icons";
import Newsletter from "./Newsletter";

export default function SocialBar() {
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const iconIdle  = useColorModeValue("#888888", "#777777");
  const iconHover = useColorModeValue("#333333", "#dddddd");

return (
    <Box pt={5} pb={1} textAlign="center">
      {/* Social icons */}
      <Flex justify="center" align="center" gap="24px" mb={4}>
        {social_list.map((social) => (
          <Link
            key={social.name}
            to={social.href}
            target="_blank"
            rel="noreferrer"
            title={social.name}
            style={{
              color: hoveredIcon === social.name ? iconHover : iconIdle,
              fontSize: "22px",
              lineHeight: 1,
              textDecoration: "none",
              transition: "color 0.25s ease",
            }}
            onMouseEnter={() => setHoveredIcon(social.name)}
            onMouseLeave={() => setHoveredIcon(null)}
          >
            <i className={social.icon} />
          </Link>
        ))}
      </Flex>

      {/* Newsletter */}
      <Box mt="40px">
        <Newsletter />
      </Box>
    </Box>
  );
}
